import { gql } from '@utils/gpl-dedup';
import { addressFragment } from '@graphql/addresses/fragments';

export const phoneFragment = gql`
  fragment phone on Phone {
    country
    phone
    code
    ext
  }
`;

export const contactFragment = gql`
  fragment contactDetailed on Contact {
    first_name
    middle_name
    last_name
    salutation
    role
    email
    phone {
      ...phone
    }
    mobile_phone {
      ...phone
    }
    emergency_phone {
      ...phone
    }
    work_phone {
      ...phone
    }
    fax {
      ...phone
    }
    preferred_contact
    billing
    primary
    address {
      ...address
    }
  }
  ${phoneFragment}
  ${addressFragment}
`;
